import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function UkPage() {
  return <CountryPageTemplate country={countryPages.uk} />;
}

export default UkPage;
